import { useMemo } from 'react';
import useOrganisation from './useOrganisation';

function useIsMscOrganisation() {
  const { selectedOrganisation, organisationName } = useOrganisation();

  return useMemo(() => {
    const currentOrganisationName = selectedOrganisation?.name ?? organisationName;
    return currentOrganisationName?.toUpperCase().includes('MSC') ?? false;
  }, [organisationName, selectedOrganisation?.name]);
}

export default useIsMscOrganisation;
